import type { FC } from 'react';
import { MdCheck, MdClear } from 'react-icons/md/index';
import ProgressBar from '../ProgressBar';
import type { IUploaderBodyProps } from './types';
import { truncateFilename } from '~/utils/string';
import clsx from 'clsx';
import { linkUnderlineClasses } from '~/utils';
import './style.css';

const parseFileSize = (size: number): string => {
	if (size < 1000000) {
		return `${(size / 1024).toFixed(2)}kB`;
	}

	return `${(size / 1024 / 1024).toFixed(2)}MB`;
};

const UploaderBody: FC<IUploaderBodyProps> = ({
	uploadProgress,
	errorMessage,
	fileSize,
	fileName,
	state,
	children,
	onReset,
}) => {
	switch (state) {
		case 'uploaded':
			return (
				<div className="flex flex-col group items-start justify-start w-full px-8 file-input-inner-text">
					<div>
						<MdCheck className="w-[5] h-[5] file-input-inner-text" />
					</div>
					<div className="w-full file-input-inner-text text-sm mb-1 flex items-center justify-between">
						{truncateFilename(fileName)}
						<button onClick={onReset} type="button">
							<MdClear className="w-5 h-5 file-input-inner-text" />
						</button>
					</div>
					<div className="text-[10px] ">{parseFileSize(fileSize)}</div>
				</div>
			);
		case 'uploading':
			return (
				<div className="flex flex-col group items-start justify-start w-full px-8">
					<div className="w-full file-input-inner-text text-sm mb-1 flex items-center justify-between">
						{truncateFilename(fileName)}
						<button onClick={onReset} type="button">
							<MdClear className="w-5 h-5 file-input-inner-text" />
						</button>
					</div>
					<ProgressBar percentageComplete={uploadProgress} className="mb-1" />
					<div className="file-input-inner-text text-xs">
						{Math.round(uploadProgress)}% {parseFileSize(fileSize)}
					</div>
				</div>
			);
		case 'error':
			return (
				<div className="flex flex-col group items-start justify-start w-full px-8">
					<div>
						<MdClear className="w-5 h-5 file-input-inner-text" />
					</div>
					<div className="w-full file-input-inner-text text-sm mb-1 flex items-center justify-between">
						{truncateFilename(fileName)}
						<button
							onClick={onReset}
							type="button"
							className={clsx('focus:ring-2', linkUnderlineClasses)}
						>
							Retry
						</button>
					</div>
					<div className="file-input-inner-text text-xs uppercase">{errorMessage}</div>
				</div>
			);
		case 'ready':
		default:
			return <>{children}</>;
	}
};

export default UploaderBody;
